// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"302":"9dfbdff1809e1c67","487":"e610ba6736629f3b","868":"23cf6a62b8a1aa98","921":"8f126987d2942956"}[chunkId] + ".js";
};